import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { generateRequestTimeLogHeader } from 'src/app/core/interceptors/log.interceptor';

@Injectable({
  providedIn: 'root',
})
export class WhatsappTemplateService {
  constructor(private httpClient: HttpClient) {}

  getTemplates(companyId: string) {
    return this.httpClient.get(
      `${environment.externalUrls.bff}/whatsapp/templates`,
      {
        params: {
          companyId,
          type: 'TEXT,TEXT_V2',
        },
        headers: generateRequestTimeLogHeader('whatsapp-templates'),
      }
    );
  }
}
